import React,{useState} from 'react';
import styled from 'styled-components'
import {media} from '../../styles/Mixin'
import BigText from '../BigText';
import NormalText from '../NormalText';
import ChangeCategoryWindow from './ChangeCategoryWindow';

const UpdateWindow = ({
    deleteClick,
    setCtgUpdateWindow,
    setCtgUpdateState,
    categoryId,
    categoryName
}) =>{
    const [state, setState] = useState("select")
    return(
        <Wrapper>
            <Box>
                <Header>
                    {
                        state === "select" && 
                        (
                            <CustomBigText text={"카테고리 수정"} />
                        )
                    }
                </Header>
                <Content>
                    {
                        state === "select" && 
                        (
                            <>
                                <DeleteBtn onClick={()=>{
                                    setState("loading")
                                    return deleteClick();
                                }}><CustomText text={"삭제"} /></DeleteBtn>
                                <NameChange onClick={()=>{setState("nameChange")}}><CustomText text={"카테고리 이름 변경"} /></NameChange>
                                <CancelBtn onClick={()=>{setCtgUpdateWindow(false)}}>
                                <BlackText text={"취소"}/></CancelBtn>
                            </>
                        )
                    }
                    {
                        state === "nameChange" &&
                        (
                            <ChangeCategoryWindow 
                                setCtgUpdateWindow={setCtgUpdateWindow}
                                setCtgUpdateState={setCtgUpdateState}
                                categoryId={categoryId}
                                categoryName={categoryName}
                            />
                        )
                    }
                    {
                        state === "loading" &&
                        (
                            <LoadingText text={"삭제중..."}/>
                        )
                    }
                </Content>
            </Box>
        </Wrapper>
    )
}


export default UpdateWindow

const Wrapper = styled.div`
    position:fixed;
    top:0;
    left:0;
    background-color: rgba(0, 0, 0, 0.5);
    height:100%;
    width:100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Box = styled.div`
   position:relative;
   display:flex;
   flex-direction:column;
   ${media.deskTop`
    width:500px;
    height:450px;
   `}
    ${media.mobile`
        width:100%;
        height:300px;
    `};
`

const Header = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    padding:10px;
    top:0;
    height:40px;
`

const CustomBigText = styled(BigText)`
    color:white;
    font-weight:bold;
`

const Content = styled.div`
    height:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    overflow-y: auto;
    ${media.deskTop`
        padding:20px;
        margin-top:30px;
   `};
    ${media.mobile`
        padding:15px;
        margin-top:20px;
    `};
    &>:not(:last-child){
      ${media.deskTop`
          margin-bottom:20px;
      `};
      ${media.mobile`
         margin-bottom:15px;
      `};
    };
`

const ShareBtn = styled.div`
    border-radius: ${props => props.theme.borderRadius};
    width:50%;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    padding:10px;
    cursor:pointer;
`

const DeleteBtn = styled(ShareBtn)`
    background-color:red;
`

const NameChange = styled(ShareBtn)`
    background-color:${props => props.theme.blueColor};
`

const CancelBtn = styled(ShareBtn)`
    background-color:${props => props.theme.lightCloudColor};
`

const CustomText = styled(NormalText)`
    color:white;
`

const BlackText = styled(NormalText)`
    color:black;
`

const LoadingText = styled(BigText)`
    color:white;
`